import { Action } from '@ngrx/store'

import { ApiOrder } from '../../cart/models/cart-models'
import { BackorderCounts } from '../models/backorder-counts';

export const SUBMIT = '[Checkout] Order'
export const SUBMIT_SUCCESS = '[Checkout] Order Success'
export const SUBMIT_FAILED = '[Checkout] Order Failed'

export const SET = '[Checkout] Set Details'
export const SET_SUCCESS = '[Checkout] Set Details Success'
export const SET_FAILED = '[Checkout] Set Details Failed'

export const GET_DELIVERY_DATES = '[Checkout] Get Delivery Dates'
export const GET_DELIVERY_DATES_SUCCESS = '[Checkout] Get Delivery Dates Success'
export const GET_DELIVERY_DATES_FAILED = '[Checkout] Get Delivery Dates Failed'
export const CLEAR_DELIVERY_DATES = '[Checkout] Clear Delivery Dates'

export const GET_BACKORDER_COUNTS = '[Checkout] Get Backorder Counts'
export const GET_BACKORDER_COUNTS_SUCCESS = '[Checkout] Get Backorder Counts Success'
export const GET_BACKORDER_COUNTS_FAILED = '[Checkout] Get Backorder Counts Failed'
export const CLEAR_BACKORDER_COUNTS = '[Checkout] Clear Backorder Counts'

export const CLEAR_ERROR = '[Checkout] Clear Error'
export const ORDER_SUMMARY = '[Checkout] Order Summary'

export class Submit implements Action {
    readonly type = SUBMIT
    constructor(public payload: ApiOrder) {}
}
export class SubmitSuccess implements Action {
    readonly type = SUBMIT_SUCCESS

    constructor(public payload: ApiOrder) {}
}
export class SubmitFailed implements Action {
    readonly type = SUBMIT_FAILED
    constructor(public payload: any) {}
}

export class Set implements Action {
    readonly type = SET
    constructor(public payload: ApiOrder) {}
}
export class SetSuccess implements Action {
    readonly type = SET_SUCCESS
    constructor(public payload: ApiOrder) {}
}
export class SetFailed implements Action {
    readonly type = SET_FAILED
    constructor(public payload: any) {}
}

export class GetDeliveryDates implements Action {
  readonly type = GET_DELIVERY_DATES
}
export class GetDeliveryDatesSuccess implements Action {
  readonly type = GET_DELIVERY_DATES_SUCCESS
  constructor(public payload: string[]) {}
}
export class GetDeliveryDatesFailed implements Action {
  readonly type = GET_DELIVERY_DATES_FAILED
  constructor(public payload: any) {}
}
export class ClearDeliveryDates implements Action {
  readonly type = CLEAR_DELIVERY_DATES
}

export class GetBackorderCounts implements Action {
  readonly type = GET_BACKORDER_COUNTS
}
export class GetBackorderCountsSuccess implements Action {
  readonly type = GET_BACKORDER_COUNTS_SUCCESS
  constructor(public payload: BackorderCounts) {}
}
export class GetBackorderCountsFailed implements Action {
  readonly type = GET_BACKORDER_COUNTS_FAILED
  constructor(public payload: any) {}
}
export class ClearBackorderCounts implements Action {
  readonly type = CLEAR_BACKORDER_COUNTS
}

export class ClearError implements Action {
    readonly type = CLEAR_ERROR
}

export class OrderSummary implements Action {
    readonly type = ORDER_SUMMARY

    constructor(public payload: string) { }
}

export type Actions =
    Submit
    | SubmitSuccess
    | SubmitFailed
    | Set
    | SetSuccess
    | SetFailed
    | GetDeliveryDates
    | GetDeliveryDatesSuccess
    | GetDeliveryDatesFailed
    | ClearDeliveryDates
    | GetBackorderCounts
    | GetBackorderCountsSuccess
    | GetBackorderCountsFailed
    | ClearBackorderCounts
    | ClearError
    | OrderSummary
